module.exports = __webpack_public_path__ + "img/thumb-008-06.8fe11103.png";